<template>
  <TabContentLayout id="general-tab">
    <b-row class="mb-2">
      <b-col>
        <SubHeaderSection
          title="Adjuntos"
          description="Archivos relacionados a la orden de servicio"
          bg-icon="#1d58b7"
          bg-color="#f0f0f0"
          class="pl-1"
        >
          <font-awesome-icon :icon="['far', 'paperclip']" size="lg" fixed-width />
        </SubHeaderSection>
      </b-col>
    </b-row>
    <!-- attachments -->
    <b-row>
      <b-col lg="5" v-if="showUploader">
        <div class="sc-sub-body">
          <div class="d-flex justify-content-center align-items-center">
            <div style="max-width: 575px; min-width: 240px">
              <AttachmentsUploader
                :allowedFileTypes="allowedFileTypes"
                :maxNumberOfFiles="8"
                :maxFileSize="10485760"
                :useDashboard="true"
                :dashboardHeight="150"
                @file-added="$emit('onFileAdded', $event)"
                @file-removed="$emit('onFileRemoved', $event)"
              />
            </div>
          </div>
        </div>
      </b-col>
      <b-col class="mt-2 mt-lg-0">
        <p className="fs-18 text-foreground mb-1">
          Archivos agregados ({{ attachments.length }})
        </p>
        <ul v-if="attachments.length" class="pl-0">
          <li
            v-for="file in attachments"
            :key="file.id"
            class="d-flex align-items-center mb-2 p-2 border rounded bg-light shadow-sm"
          >
            <div class="file-preview d-flex align-items-center justify-content-center mr-3">
              <img
                v-if="file.type == 'image'"
                :src="file.img_url"
                :alt="file.caption"
                class="img-fluid preview-img"
              />
              <font-awesome-icon v-else :icon="['far', 'file-alt']" fixed-width size="xl" class="text-secondary" />
            </div>

            <div class="d-flex flex-column flex-grow-1 justify-content-center">
              <b-link
                class="text-truncate fs-15"
                @click="handleOnClickAttachment(file)"
              >
                <span v-if="file.type == 'document'">
                  <span>{{ file.name }}</span>
                </span>
                <span v-else>
                  <span>{{ file.caption }}</span>
                </span>
              </b-link>
              <p class="text-muted mb-0 fs-12" style="line-height: 13px;">
                {{ file.created_at | formatDateTime }}
              </p>
            </div>


            <button
              v-if="!isDev"
              type="button"
              class="btn btn-sm btn-link text-muted ml-2"
              @click="$emit('onFileRemoved', file)"
            >
              <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width />
            </button>
          </li>
        </ul>
        <div v-else class="ts-summary-card-empty">
          <p class="text-secondary text-center mb-0 fs-18">La orden no cuenta con documentos relacionados</p>
        </div>
      </b-col>
    </b-row>
  </TabContentLayout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TabContentLayout from './TabContentLayout'
  import SubHeaderSection from '../SubHeaderSection'
  import AttachmentsUploader from '../../../shared/AttachmentsUploader'
  import { allowedFileTypes } from '../../../../sharedOptions/serviceCallModule'

  export default {
    name: 'AttachmentsTab',
    props: {
      attachments: {
        type: Array,
        required: true,
        default: () => ([])
      }
    },
    components: { TabContentLayout, SubHeaderSection, AttachmentsUploader },
    data() {
      return {
        id: Number(this.$route.params.id),
        processing: false,
        allowedFileTypes: allowedFileTypes
      }
    },
    computed: {
      ...mapGetters(['isDev', 'isOsGestor']),
      attachmentsMode () {
        const { attachments } = this.$route.query
        if (attachments === 'true') return true

        return  false
      },
      showUploader () {
        if (this.attachmentsMode) return false

        return this.isOsGestor
      }
    },
    methods: {
      handleOnClickAttachment (file) {
        if (this.processing) { return }
        this.processing = true

        if (file.type == 'image') {
          this.$http.get(`/api/production/service_calls/${this.id}/photos/${file.id}`)
            .then((resp) => {
              this.$emit('showFullImage', resp.data.presigned_url)
            })
            .catch(e => console.log(e))
            .finally(() => this.processing = false)
        } else {
          this.$http.get(`/api/production/service_calls/${this.id}/documents/${file.id}/download`)
            .then((resp) => {
              const url = resp.data
              const link = document.createElement('a')
              link.href = url
              link.download = file.name
              document.body.appendChild(link)
              link.click()
              link.remove()
            })
            .catch(e => console.log(e))
            .finally(this.processing = false)
        }
      }
    }
  }
</script>

<style scoped>
.file-preview {
  width: 35px;
  height: 35px;
  overflow: hidden;
  border-radius: 6px;
  background: #e9ecef;
  flex-shrink: 0;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.text-truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ts-summary-card-empty { border: 1px solid #a9b4cf6d; border-radius: 9px; background: #e9ecef; padding: 14px 16px; }
</style>
